/**
 * Device Operations Duration Cell - Frontend
 * @description Cell component for displaying operation duration
 */

import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { OperationResponse } from '@/types/operation.types';

export const DeviceOperationsDurationCell: React.FC<{
  info: CellContext<OperationResponse, number>;
}> = ({ info }) => {
  const row = info.row.original;

  return <div>{row.durationMinutes && <div>{row.durationMinutes} min</div>}</div>;
};
